import Image from 'app/Components/Shared/Image/image';
import React, { useState, useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import ProviderManager from '../../../provider/providerManager';
import { createAsyncThunk } from '@reduxjs/toolkit';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import ThirdParty from '../../Shared/ThirdParty/ThirdParty';
import Loader  from '../../Shared/LocalLoader/LocalLoader';
import Config from '../../../Config';
import { dwhThirdPartyPopupDisplay , dwhThirdPartyConfirm , dwhThirdPartyError} from './dwhReports';
import { gtag4 } from "../../../utilities/analytics/tracking";

const ThirdPartyAgreementsData = (props) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [buttonStatus, setButtonStatus] = useState(false);
  const [ThirdPartyFullText, setThirdPartyFullText] = useState('');
  var data = props.data;
  const popupMainTitle = data?.mainTitle?.value || '';
  const popupSecondaryTitle = data?.secondaryTitle?.value || '';
  const icon = data?.popupLogo?.value?.url || '';
  const ConfirmCollaborationText = data?.confirmCollaboration?.value || 'אני מעוניין';
  const RejectsCollaborationText = data?.rejectsCollaboration?.value || 'לא כרגע';


  const handleSubmit = async () => {
    try {
      setIsLoading(true);
      const response = await dispatch(UpdateCollaborationStatus(true));
      setIsLoading(true)
      if (response.payload.Body.isSuccess == true) {
        props.onClosePopup();
      }
    } catch (error) {
      throw error;
    }
  };


  const handleButtonStatus = (data) => {
    setButtonStatus(data)
  };

  const removeHTMLTags = (html) => {
    return html.replace(/<[^>]*>?/gm, '');
  };

  const handleAllTextUpdate = (text) => {
    setThirdPartyFullText(removeHTMLTags(text));
  };

  const UpdateCollaborationStatus = createAsyncThunk('ThirdParty/CollaborationUpdate', async (data, thunkAPI) => {

    const { customerName, phoneNumber, contactId } = props;
    var params = {
      CollaborationVal: data
    };

    gtag4({
      event: "ThirdPartyAgreement_PopupButtonClick",
      title: popupMainTitle,
      content : ThirdPartyFullText,
      button : ConfirmCollaborationText,
      action : 'PopupButtonClick'
    });

    try {
      var result = await ProviderManager.getProviderData('CollaborationUpdate', params);
      if(result?.Body?.isSuccess){
        dwhThirdPartyConfirm(customerName,phoneNumber,contactId);
      }
      else{
        dwhThirdPartyError(customerName,phoneNumber,contactId);
      }
      return result;
    } catch (error) {
      dwhThirdPartyError(customerName,phoneNumber,contactId);
      throw error;
    }
  });

  useEffect(() => {
    dwhThirdPartyPopupDisplay( props.customerName,props.phoneNumber, props.contactId);
    gtag4({
      event: "ThirdPartyAgreement_PopupImp",
      title: popupMainTitle,
      content : ThirdPartyFullText,
      action : 'PopupImp'
    });

  }, []);



  return (

    <div className={`third-party-popup-container ${buttonStatus ? "openText" : "closeText"}`}>
     {isLoading && (
        <div className="overlay">
          <Loader />
        </div>
      )}
      {icon !== '' && (
        <div className="icon-alert">
          <Image src={Config.epiBaseUrl + icon} />
        </div>
      )}
      <div className="title">{popupMainTitle}</div>
      <div className="sub-title">{popupSecondaryTitle}</div>
      <ThirdParty sendButtonStatus={handleButtonStatus}  sendThirdPartyText={handleAllTextUpdate} />
      <div className={`buttons ${buttonStatus ? "openText" : "closeText"}`}>
        <div className="submit-button-wrapper">
          <BtnSubmit
            className=""
            isBusiness={false}
            text={ConfirmCollaborationText}
            onclick={() => handleSubmit()}
            isDisplayArrows={false}
          />
        </div>
        <input
          type="button"
          onClick={() => {
            props.onClosePopup();
          }}
          className="third-party-btn-remind"
          value={RejectsCollaborationText}
        />
      </div>

    </div>
  );

};

const mapStateToProps = state => {
  return {
    cmsContent: state.iContentRepo,
    contactId: state.authentication?.loginData?.userDetails?.IDNumber,
    customerName: state.authentication?.loginData?.userDetails?.firstName + ' ' + state.authentication?.loginData?.userDetails?.lastName,
    phoneNumber :  state.authentication?.loginData?.userDetails?.contactNumber,
  };
};
export default connect(mapStateToProps, null)(ThirdPartyAgreementsData);
